module.exports = __webpack_public_path__ + "img/form.1854369d.webp";